import cookies from "browser-cookies"
import { nostojs } from "./api"

const storage = {
  get: (key: string) => {
    const valueFromSession = sessionStorage.getItem(key)
    if (valueFromSession) {
      return valueFromSession
    }
    // initial fallback to cookies
    const valueFromCookie = cookies.get(key)
    if (valueFromCookie) {
      sessionStorage.setItem(key, valueFromCookie)
      return valueFromCookie
    }
    return null
  },
  set: (key: string, value: string) => {
    sessionStorage.setItem(key, value)
  }
}

const overlayHeight = "85px"

const nostoMarketsPreviewOverlayHTML = `
  <html>
  <head>
    <title>Preview</title>
    <style>
    
      body {
        font-family: Roboto Mono, sans-serif;
        height: ${overlayHeight};
        margin: 0 10px 0 10px;
      }
      
      .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #F8F8F8;
        height: inherit;
        animation: drop-in 1s ease 200ms backwards;
        background: rgba(24, 19, 44, 0.565);
        padding: 0 10px 0 10px;
        border-radius: 5px;
      }
      
      .overlay-logo {
        display: flex;
        height: auto;
        width: 15%;
        padding: 10px;
      }
      
      .title {
        font-weight: bold;
        display: inherit;
        height: auto;
        padding: 0;
        margin: 0;
      }
      
      .close-preview-button {
        padding: 10px 10px;
        background-color: #6761E7;
        width: 10em;
        border: none;
        border-radius: 3px;
        cursor: pointer;
        color: #F8F8F8;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
      }
      
      @keyframes drop-in {
        from {
          opacity: 0;
          transform: translateY(-100px);
        }
        to {
          opacity: 1;
          transform: translate(0px);
        }
     }
    </style>
  </head>
  <body>
    <div class="container">
          <img src="NOSTO_SERVER/assets/public/images/foundation5/logo-nosto-inverse.png" alt="Nosto" class="overlay-logo">
          <h3 class="title">Shopify Markets Preview MARKET_LANGUAGE</h3>
        <button class="close-preview-button" onclick="closePreview()"><b>Close preview</b></button>
    </div>
  
    <script>
      function closePreview() {
        sessionStorage.setItem("nostomarketspreview", "false");
        const url = new URL(window.top.location.href);
        url.searchParams.delete('nostomarketspreview');
        window.top.location.href = url.toString()
      }
    </script>
  </body>
  </html>
`

export default () => {
  nostojs(api => {
    const nostoSettings = api.internal.getSettings()
    let sanitizedOverlayHTML = nostoMarketsPreviewOverlayHTML.replace("NOSTO_SERVER", nostoSettings.server)

    if (window && window.Shopify && window.Shopify.locale && window.Shopify.country) {
      const customerLocale = window.Shopify.locale
      const customerCountry = window.Shopify.country
      sanitizedOverlayHTML = sanitizedOverlayHTML.replace(
        "MARKET_LANGUAGE",
        `| ${customerCountry.toUpperCase()} | ${customerLocale.toUpperCase()}`
      )
    } else {
      sanitizedOverlayHTML = sanitizedOverlayHTML.replace("MARKET_LANGUAGE", "")
    }

    if (storage.get("nostomarketspreview") === "true") {
      const nostoMarketsPreviewIframe = document.createElement("iframe")
      nostoMarketsPreviewIframe.title = "Nosto Markets Preview"
      nostoMarketsPreviewIframe.id = "nosto-markets-preview"
      nostoMarketsPreviewIframe.srcdoc = sanitizedOverlayHTML
      nostoMarketsPreviewIframe.scrolling = "no"

      const styles = {
        position: "fixed",
        bottom: "25px",
        "z-index": 2147483647,
        width: "50%",
        border: "none",
        overflow: "hidden",
        transform: "translate(50%, 0%)",
        height: overlayHeight,
        display: "none"
      }

      Object.assign(nostoMarketsPreviewIframe.style, styles)

      nostoMarketsPreviewIframe.setAttribute("sandbox", "allow-scripts allow-same-origin allow-top-navigation")
      document.body.appendChild(nostoMarketsPreviewIframe)

      nostoMarketsPreviewIframe.addEventListener("load", () => {
        nostoMarketsPreviewIframe.style.display = "block"
      })
    } else {
      const nostoMarketsPreviewIframe = document.getElementById("nosto-markets-preview")
      if (nostoMarketsPreviewIframe) {
        nostoMarketsPreviewIframe.remove()
      }
    }
    return true
  })
}
